export default __webpack_public_path__ + "static/media/icon-6.f1150f4b.svg";